import { syncraApi, syncraApiAdapter, ApiError } from '@/api/main/syncraClient'
import { TraderReferralListPayloadListResult } from 'syncra-api-client'
import { DateRange } from 'react-day-picker'
import { normalizeDateRangeForList } from '@/shared/lib/date'
import type { QueryObserverResult, RefetchOptions } from '@tanstack/react-query'

interface UseReferralDataParams {
  referralId?: string
  dateRange?: DateRange
}

interface UseReferralDataReturn {
  data: TraderReferralListPayloadListResult | undefined
  isLoading: boolean
  error: ApiError | null
  refetch: (options?: RefetchOptions) => Promise<QueryObserverResult<TraderReferralListPayloadListResult, ApiError>>
}

export const useReferralData = ({
  referralId,
  dateRange,
}: UseReferralDataParams): UseReferralDataReturn => {
  // Нормализуем даты для API запроса
  const { startDate, endDate } = normalizeDateRangeForList(dateRange)

  const { data, isLoading, error, refetch } = syncraApiAdapter.createQueryHook<TraderReferralListPayloadListResult>(
    ['referral-data', referralId, startDate, endDate],
    () => syncraApi.v1.traderReferralsList({
      search: referralId,
      startDate,
      endDate,
      take: 1,
      skip: 0,
    }),
    {
      enabled: !!referralId
    }
  )()

  return {
    data,
    isLoading,
    error: error as ApiError | null,
    refetch,
  }
}
